import { usePathname } from "next/navigation"

import { PREFILTERED_BASENAME } from "@/modules/jobSearchPrefiltered/constants"

export const usePrefilteredJobSearch = (): boolean => {
  const pathname = usePathname()
  const [, , pagePath] = pathname.split("/")

  return pagePath === PREFILTERED_BASENAME
}
